import * as PropTypes from 'prop-types'
import { Suspense, useEffect, useRef, useState } from 'react'
import { EditMenuBtn, SubMenuBlock, SubmenusLink } from './styled-components'
import moreDotsIcon from '@images/moredotsicon.svg'
import moreDotsWhiteIcon from '@images/moredotswhiteicon.svg'
import Button, { BUTTON_TYPES } from '../Button'
import SubmenuNewItems from './components/submenu-new-items'

const SubmenuNew = ({
  maxDistanceToBottom,
  type,
  menuItems,
  style,
  isWhite,
  testId,
  icon,
  disabled,
  iconStyle,
  className,
  children = () => null,
  withShadow = true
}) => {
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const [direction, setDirection] = useState(null)
  const [parentDefaultZIndex, setParentDefaultZIndex] = useState(null)

  const menuBlockRef = useRef()

  const handleToggleSubmenu = (e) => {
    e.stopPropagation()
    const menuBlock = menuBlockRef.current

    const direction =
      !!maxDistanceToBottom &&
      window.innerHeight - menuBlock.getBoundingClientRect().bottom <
        maxDistanceToBottom
        ? 'up'
        : undefined

    if (maxDistanceToBottom) {
      menuBlock.parentNode.style.zIndex = visible ? parentDefaultZIndex : 99999
    }

    setOpen(true)
    setDirection(direction)
    setVisible(!visible)
  }

  const src = icon || (isWhite ? moreDotsWhiteIcon : moreDotsIcon)

  useEffect(() => {
    const menuBlock = menuBlockRef.current
    if (menuBlock) {
      setParentDefaultZIndex(menuBlock.parentNode.style.zIndex)
    }
  }, [])

  const handleSetOpen = (visible) => {
    const menuBlock = menuBlockRef.current

    if (maxDistanceToBottom) {
      menuBlock.parentNode.style.zIndex = visible ? 200 : parentDefaultZIndex
    }

    setVisible(visible)
  }

  if (menuItems?.every((el) => el.hide) || !type) {
    return null
  }

  if (type === 'link') {
    return (
      <SubmenusLink
        ref={menuBlockRef}
        data-testid={testId}
        open={open}
        header={menuItems?.filter((item) => item.header).length}
        className={className}
      >
        <li>
          <Button
            onClick={handleToggleSubmenu}
            disabled={disabled}
            style={{ margin: 0 }}
            type={BUTTON_TYPES.round}
            size={56}
            withShadow={withShadow}
            noBorder
          >
            <img src={src} alt="submenu" style={iconStyle} />
          </Button>
          {open && (
            <Suspense fallback={null}>
              <SubmenuNewItems
                items={menuItems}
                style={style}
                toggleSubmenu={handleToggleSubmenu}
                show={visible}
                setOpen={handleSetOpen}
                type={type}
                parentRef={menuBlockRef}
              />
            </Suspense>
          )}
        </li>
      </SubmenusLink>
    )
  }

  return (
    <SubMenuBlock
      className={className}
      ref={menuBlockRef}
      direction={direction}
      data-testid={testId}
      top={style?.top ?? false}
      header={menuItems?.filter((item) => item.header).length}
    >
      <EditMenuBtn onClick={handleToggleSubmenu} disabled={disabled}>
        <img src={src} alt="submenu" style={iconStyle} />
      </EditMenuBtn>
      {open && (
        <Suspense fallback={null}>
          <SubmenuNewItems
            items={menuItems}
            style={style}
            show={visible}
            toggleSubmenu={handleToggleSubmenu}
            setOpen={handleSetOpen}
            type={type}
            parentRef={menuBlockRef}
          >
            {children({ toggleSubmenu: handleToggleSubmenu })}
          </SubmenuNewItems>
        </Suspense>
      )}
    </SubMenuBlock>
  )
}

SubmenuNew.propTypes = {
  menuItems: PropTypes.array,
  type: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconStyle: PropTypes.object,
  testId: PropTypes.string,
  style: PropTypes.object,
  isWhite: PropTypes.bool,
  disabled: PropTypes.bool,
  maxDistanceToBottom: PropTypes.number,
  className: PropTypes.string,
  withShadow: PropTypes.bool,
  children: PropTypes.func
}

export default SubmenuNew
